import { types } from "../../types/types";

const initialState = {
  cargada: false,
  items: [],
  loading: false,
  error: null,
};
export const certificadosAfiliacionReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case types.certificadosTraerCargadaStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.certificadosTraerCargadaSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.certificadosTraerCargadaError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        cargada: false,
      };
    case types.certificadosLimpiarLista:
      return {
        loading: false,
        error: null,
        items: [],
        cargada: false,
      };
    case types.certificadosInsertSuccess:
      return {
        ...state,
        loading: false,
        cargada: true,
        items: [action.payload, ...state.items],
      };
    case types.certificadosUpdated:
      return {
        ...state,
        cargada: true,
        items: state.items.map((item) =>
          item.idItem ===
          action.payload.idItem
            ? {
                ...item,
                // tipoCertificado: action.payload.tipoCertificado,
                // fecha: action.payload.fecha,
                // fechaVencimiento: action.payload.fechaVencimiento,
                ...action.payload
              }
            : item
        ),
      };
    case types.certificadosImageUploaded:
      return {
        ...state,
        cargada: true,
        items: state.items.map((item) =>
        item.idItem ===
        action.payload.idCertificado
          ? {
              ...item,
              imagenCertificado: [action.payload, ...item.imagenCertificado],
            }
          : item
      ),
      };
    case types.certificadosImageDelete:
      return {
        ...state,
        cargada: true,
        items: state.items.map((item) =>
          item.idItem === action.payload.idCertificado
            ? {
                ...item,
                imagenCertificado: item.imagenCertificado.filter(img => 
                  img.idItem !==  action.payload.idFileCertificado
                ),
              }
            : item
        ),
      }
    case types.certificadosDelete:
      return {
        ...state,
        cargada: true,
        items: state.items.filter(
          (item) => parseInt(item.idItem) !== parseInt(action.payload)
        ),
      };

    default:
      return state;
  }
};
